export enum MhaStatus {
  PENDING = 'Pending',
  HEALTHY = 'Healthy',
  FAILURE = 'Failure',
  RUNNING = 'Running'
}
